import Model from 'modules/reports/orm/Model'

export default class ReportEmail extends Model {
  id: number
  to: (number | string)[]
  subject: string
  body: string
  format: 'excel' | 'csv' | 'pdf'
  created_at: string

  get formattedLastEmail() {
    return '10/15/2019'
  }
}
